import React from 'react';
import Button from "../ui/Button/Button";
import styles from './DocumentsType.module.sass';
import api from "../../utils/api";
import gaTags from './../../utils/ga-tags';

const DocumentsType = (props) => {

  const downloadHandler = (filename, endpoint) => {
    api.get(endpoint, { codigo: props.proposta },
      { codigoUsuario: api.CODIGO_USUARIO() }, { responseType: 'blob' }).then((result) => {
        const blob = result.data;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
  };

  const gaTypeName = `${gaTags.typeFlow2.concat("5-")}&CheckOut-Sucesso`
  return (
    <div className={styles.content}>
      <p>Alguns documentos importantes pra você.</p>
      <div className={styles.buttonsList}>
        <Button
          className={styles.buttonItem}
          onClick={() => downloadHandler('proposta.pdf', api.endpoints.DOWNLOAD_PROPOSTA)}
          data-gacategory={gaTags.categoryFlow}
          data-gatype={gaTypeName}
          data-gafunc={`${gaTypeName}-Proposta`}>
          <i className="icon icon-download" />
          Proposta
        </Button>
        <Button
          className={styles.buttonItem}
          onClick={() => downloadHandler('contrato.pdf', api.endpoints.DOWNLOAD_CONTRATO)}
          data-gacategory={gaTags.categoryFlow}
          data-gatype={gaTypeName}
          data-gafunc={`${gaTypeName}-Contrato`}>
          <i className="icon icon-download" />
          Contrato
        </Button>
      </div>

    </div>
  )

};

export default DocumentsType
